import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import FadeIn from '@components/shared/FadeIn';

export interface CartItemRowProps {
  imageComponent?: React.ReactNode;
  titleComponent: React.ReactNode;
  subtitleComponent?: React.ReactNode;
  priceComponent: React.ReactNode;
  actionsComponent?: React.ReactNode;
  extraContent?: React.ReactNode;
  className?: string;
}

const CartItemRow: React.FC<CartItemRowProps> = ({
  imageComponent,
  titleComponent,
  subtitleComponent,
  priceComponent,
  actionsComponent,
  extraContent,
  className
}) => {
  return (
    <Container className={className}>
      <FadeIn duration={400}>
        <Row>
          {imageComponent && <ImageWrap>{imageComponent}</ImageWrap>}
          <Info>
            <TitleContainer>
              <Title>{titleComponent}</Title>
              {subtitleComponent && <Subtitle>{subtitleComponent}</Subtitle>}
            </TitleContainer>
            {actionsComponent && <Actions>{actionsComponent}</Actions>}
          </Info>
          <Price>{priceComponent}</Price>
        </Row>
        <ExtraContent>{extraContent}</ExtraContent>
      </FadeIn>
    </Container>
  );
};

export default CartItemRow;

const Container = styled.div`
  &:not(:first-child) {
    padding: 30px 0 0;
  }

  &.last-child-divider:last-child {
    border-bottom: 1px solid ${Colors.ecru50};
    padding-bottom: 30px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ImageWrap = styled.div`
  width: 40px;
  min-width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 15px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: 10px;
`;

const Title = styled.h5`
  font-size: 14px;
  line-height: 22px;
  font-family: 'BrownStd';
  color: inherit;
  margin: 0;
`;

const Subtitle = styled.span`
  font-size: 13px;
  line-height: 16px;
  opacity: 0.5;
  margin-top: 4px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
`;

const Price = styled.div`
  min-width: 60px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  font-family: 'BrownStd';
  font-weight: 700;
  margin-left: 5px;
`;

const ExtraContent = styled.div`
  margin-top: 10px;
`;
